import {
  type DrawingCanvasPointStyle,
  type DrawingCanvasShape,
  DrawingCanvasShapeType,
  type Point,
  PointShape,
  type RGBColor,
} from '../types';
import {
  defaultFillColor,
  defaultLineWidth,
  defaultStrokeColor,
  hitRegionBuffer,
  selectedFillColor,
  strokeHighlight,
} from './common';

export const pointRadius = 5;

export const renderPoint = (point: Point, ctx: CanvasRenderingContext2D, style?: DrawingCanvasPointStyle): void => {
  const pointShape = style?.pointShape ?? PointShape.ROUND;
  ctx.beginPath();
  if (pointShape === PointShape.SQUARE) {
    ctx.rect(point.x - pointRadius, point.y - pointRadius, pointRadius * 2, pointRadius * 2);
  } else {
    ctx.arc(point.x, point.y, pointRadius, 0, 2 * Math.PI);
    ctx.closePath();
  }
  if (style?.isHighlighted) strokeHighlight(ctx, style);
  ctx.fillStyle = style?.isSelected ? selectedFillColor(ctx) : (style?.fillColor ?? defaultFillColor(ctx));
  ctx.strokeStyle = style?.strokeColor ?? defaultStrokeColor(ctx);
  ctx.lineWidth = style?.lineWidth ?? defaultLineWidth;
  ctx.fill();
  ctx.stroke();
};

export const renderPointHitRegion = (
  point: Point,
  ctx: CanvasRenderingContext2D,
  color: RGBColor,
  originalStyle?: DrawingCanvasPointStyle,
): void => {
  // Fill only: a stroke overlapping its own fill leaves off-color pixels that match no shape
  const hitRadius = pointRadius + ((originalStyle?.lineWidth ?? defaultLineWidth) + hitRegionBuffer) / 2;
  ctx.beginPath();
  ctx.fillStyle = color;
  if (originalStyle?.pointShape === PointShape.SQUARE) {
    ctx.fillRect(point.x - hitRadius, point.y - hitRadius, hitRadius * 2, hitRadius * 2);
  } else {
    ctx.arc(point.x, point.y, hitRadius, 0, 2 * Math.PI);
    ctx.closePath();
    ctx.fill();
  }
};

export const isValidPoint = (drawingShape: Pick<DrawingCanvasShape, 'type' | 'points'>): boolean => {
  return drawingShape.type === DrawingCanvasShapeType.POINT && drawingShape.points.length === 1;
};
